import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { PasswordValidation } from '../../mnt-admin/password-validation';

export interface DialogData {
  saveFrom: string;
}

@Component({
  selector: 'app-register-client',
  templateUrl: './register-client.component.html',
  styleUrls: ['./register-client.component.css'] 
}) 
export class RegisterClientComponent implements OnInit {
  registerClientForm: FormGroup;
  loading: false;
  public result = "";
  public profileIconText = "";
  public selectedFile = null;
  public validate_address=false;
  public userDetails:any={};
  public countryList:Array<any>=[]; 
  public isPublicQuoteCreation = false;
  constructor(private fb: FormBuilder,
    private _flashMessagesService: FlashMessagesService,
    public dialogRef: MatDialogRef<RegisterClientComponent>,
    private CommonService: CommonService,
    private router: Router,
    private CommonProjectDataService: CommonProjectDataService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
    this.registerClientForm = this.fb.group({
      email: [null, [Validators.email, Validators.required]],
      password: [null, [Validators.required, Validators.minLength(8)]],
      confirm_password: [null, Validators.required],
      phone: [null],
      company: [null],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      profile_img: [null],
      shippingAddress1: [null],
      shippingAddress2: [null],
      shippingCity: [null],
      shippingState: [null],
      shippingZip: [null],
      country: [null]
    }, {
      validator: PasswordValidation.MatchPassword
    });
  }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));  
    this.countryList=this.CommonProjectDataService.getCountryList(); 
  }

  saveClientFormData = function (postData) {
    if (this.registerClientForm.valid) {
      this.loading = true;
      // Update the postData object in place with the sanitized values.
      Object.keys(postData).forEach(key => {
        const value = postData[key];
        postData[key] = value === '' ? null : value;
      });

      const formData = new FormData();
      formData.append('register_type', 'Register');
      formData.append('id', localStorage.getItem("userID"));
      formData.append('first_name', postData.firstName);
      formData.append('last_name', postData.lastName);
      formData.append('email', postData.email);
      formData.append('username', postData.email);
      formData.append('password', postData.password);
      formData.append('confirm_password', postData.confirm_password);
      formData.append('shipping_address1', postData.shippingAddress1);
      formData.append('shipping_address2', postData.shippingAddress2);
      formData.append('shipping_city', postData.shippingCity);
      formData.append('shipping_state', postData.shippingState);
      formData.append('shipping_zip', postData.shippingZip);
      formData.append('country', this.countryList[0].countryCode);
      formData.append('phone', postData.phone);
      if(this.selectedFile){
        formData.append('profile_img', this.selectedFile, this.selectedFile.name);
      }
      this.validate_address = false;
      formData.append('validate_address',this.validate_address);
      if(postData.company)
      formData.append('company_name',postData.company);


      this.CommonService.apiService(
        "POST",
        "user/create",
        formData
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {
            localStorage.setItem("clientUserDetails", JSON.stringify(response.data));
            this.result = response.data;
            this.onNoClick();
          }
          window.scrollTo(0, 0);
        },
        err => {
          this.loading = false;
          this._flashMessagesService.show(err.error.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      );
    } else {
      this.validateAllFormFields(this.registerClientForm);
    }
  };

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  isFieldValid(field: string) {
    return (
      !this.registerClientForm.get(field).valid &&
      this.registerClientForm.get(field).touched
    );
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  onProfileChanged = function (event) {
    this.selectedFile = event.target.files[0];
    this.profileIconText = this.selectedFile.name;
  }

}



// WEBPACK FOOTER //
// /var/www/staging.theprintlife.com/src/app/mnt-master/register-client/register-client.component.ts